import { LandingScreen } from './landing-screen'
import { useLandingPageQuery } from './queries/use-landing-page.query'

export const LandingScreenContainer = () => {
  const { data, loading } = useLandingPageQuery()
  const { hero, features, meta } = data?.HomePage || {}

  return <LandingScreen hero={hero} features={features} meta={meta} loading={loading} />
}
